import Box, { type BoxProps } from '@mui/material/Box';
import type { KeyboardEvent, PropsWithChildren } from 'react';
export type TabProps = BoxProps & {
  htmlFor: string;
  id: string;
  activeTabColor?: string;
  activeTabHoverColor?: string;
  variant?: 'default' | 'condensed';
};
export function Tab({
  htmlFor,
  id,
  children,
  activeTabColor = 'yellows.lighter-2',
  activeTabHoverColor = 'yellows.light',
  variant = 'default',
  ...props
}: PropsWithChildren<TabProps>) {
  const {
    sx,
    ...rest
  } = props;
  return <Box {...props} component="label" htmlFor={htmlFor} tabIndex={0} id={`${htmlFor}-nav-label`} sx={{
    cursor: 'pointer',
    transition: 'all 0.2s, font-weight 0s',
    display: 'flex',
    gap: 3,
    alignItems: 'center',
    borderLeft: '4px solid',
    borderColor: 'transparent',
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    paddingLeft: 2,
    paddingY: variant === 'condensed' ? 2 : 3,
    paddingRight: 3,
    width: '100%',
    touchAction: 'none',
    '&:hover, &:focus-visible': {
      backgroundColor: 'neutral.lightest',
      borderColor: 'greens.main'
    },
    '&:focus-visible': {
      outline: '2px solid',
      outlineColor: 'blues.light',
      outlineOffset: 3,
      zIndex: 1
    },
    [`#${id}:has(input#${htmlFor}:checked) &`]: {
      fontWeight: variant === 'condensed' ? 700 : 'normal',
      backgroundColor: activeTabColor ?? 'yellows.lighter-2',
      borderColor: 'greens.main',
      '&:hover': {
        backgroundColor: activeTabHoverColor ?? 'yellows.light'
      }
    },
    ...sx
  }} onKeyDown={(e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.currentTarget.click();
    }
  }} {...rest}>
      {children}
    </Box>;
}